import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const studyLogApi = createApi({
  baseQuery,
  reducerPath: 'studyLogApi',
  endpoints: builder => ({
    getStudyLog: builder.query<any, any>({
      query: ({ site_id, study_id, country, application_section }) => ({
        url: `${formatString(
          endPoints.conductStudyLog.getAll
        )}?application_section=${application_section}&application_module_section=STUDY%20LOGS${
          study_id !== null ? `&study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${site_id !== null ? `&site_id=${site_id}` : ''}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getAccessStudyLogs: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.AccessStudyLogs.getStudyLogs,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?application_module_section=STUDY%20LOGS&country=${country}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getActionLogData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.conductStudyLog.selectActionLogData,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      })
    }),

    getProtocolDeviationLogData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.conductStudyLog.selectProtocolDeviationData,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      })
    }),

    getSiteStudyPersonnel: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.SiteStudyPersonnel.siteStudyPersonnelSelect,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      })
    }),
    getCommonStudyLogs: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application = 'CTMS', application_section }) => ({
        url: `${formatString(
          endPoints.StudyLogs.getAll
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&application_section=${application_section}&application_module_section=STUDY%20LOGS`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetStudyLogQuery,
  useLazyGetAccessStudyLogsQuery,
  useGetCommonStudyLogsMutation,
  useLazyGetActionLogDataQuery,
  useLazyGetProtocolDeviationLogDataQuery,
  useLazyGetSiteStudyPersonnelQuery
} = studyLogApi;
